module.exports = __webpack_public_path__ + "static/the-effective-executive-d3d4a31b82ebd23c6ea06232956a0be1.jpg";